<template>
    <div class="v--modal-box v--modal vue-dialog">
        <div class="dialog-content">
            <div class="dialog-c-title">Запрос на переделку заказ № {{order.SferaNumber}}</div>
            <div class="dialog-c-text">
                <textarea v-model="message" cols="30" rows="5" class="form-control"></textarea>
            </div>
        </div>
        <div class="vue-dialog-buttons">
            <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click.prevent="submit">ОК</button>
            <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click="$emit('close')">Отмена</button>
        </div>
        <v-dialog @closed="$emit('close')"/>
    </div>
</template>
<script>
import { get, post } from '@/admin/services/api/http-utils';

const url = process.env.VUE_APP_API_HOST;
export default {
  name: 'RecastRequest',
  props: {
    orderItemId: Number,
  },
  data() {
    return {
      order: {},
      message: '',
    };
  },
  async mounted() {
    await this.fetchOrder();
  },
  methods: {
    async fetchOrder() {
      const { data } = await get(`${url}admin/order/${this.orderItemId}`);
      this.order = data;
    },
    async submit() {
      console.log({ OrderId: this.order.Id, Message: this.message });
      await post(`${url}admin/recast-request`, { OrderItemId: this.order.Id, Message: this.message });
      this.$modal.show('dialog', {
        title: 'Запрос отправлен!',
      }, {
        pivotY: 0.2,
      });
      // this.$emit('close');
    },
  },
};
</script>
